<script>
export default {
  name: 'view-abs-thermo',
  props: {
    value: { type: Object, default: () => {} }
  },
  data () {
    return {
      specs: {
        date_delivery: null,
        foot_plate_width: null
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        if (v) this.specs = { ...this.value }
      },
      immediate: true
    }
  }
}
</script>
<template>
  <b-row no-gutters align-v="start" align-h="center">
    <b-col align-self="start">
      <p class="p-0 my-2 mb-2">
        <i class="text-muted mr-2">{{ $t(`attribute.date_delivery.key`) }}: </i>
        {{ specs.date_delivery | moment('dddd DD MMM, YYYY') }}
      </p>

      <p class="p-0 m-0 mb-2">
        <i class="text-muted mr-2"
          >{{ $t(`attribute.foot_plate_width.key`) }}:
        </i>
        <template v-if="!!specs.foot_plate_width">
          {{
            $t(`attribute.foot_plate_width.value`, {
              value: specs.foot_plate_width
            })
          }}
        </template>
        <template v-else>{{ $t('attribute.foot_plate_width.none') }}</template>
      </p>
    </b-col>
  </b-row>
</template>
